// src/pages/auth/ForgetPassword.js

import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Link } from 'react-router-dom';

export default function ForgetPassword() {
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    // Add your password reset logic here
    console.log("Reset password for:", email);
  };

  return (
    <>
      {/* old style */}
      {/* <div>
        <h1 className='text-xl text-center uppercase tracking-wider'>Xanadu</h1>
        <h1 className='text-2xl text-center font-semibold mb-3'>Reset your password</h1>

        <form className='flex flex-col space-y-4 w-full max-w-sm pt-3' onSubmit={handleSubmit}>
          <div className="space-y-1">
            <Label htmlFor="email">Email</Label>
            <div className="relative">
              <Input
                required
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white dark:bg-secondary focus-visible:ring-primary-foreground"
              />
            </div>
          </div>
          <div className="flex justify-between">
              <Link to="/" className="pt-2 text-sm text-primary font-semibold mr-4 hidden lg:block">
                Sign in existing account
              </Link>
              <Link to="/" className="pt-2 text-sm text-primary font-semibold mr-4 block lg:hidden">
                Sign in
              </Link>
              <Button className="w-auto">Reset Password</Button>
            </div>
        </form>
      </div> */}

      {/* new style */}
      <div>
        <div className='w-full'>
            <h1 className='text-2xl uppercase tracking-wider mb-5'>Xanadu</h1>
            <h1 className='text-l font-semibold mb-1 text-gray-500'>Forgot your password?</h1>
            <h1 className='text-l font-semibold mb-3'>Use the form below to recover it</h1>
          </div>
          <form className='flex flex-col space-y-4 w-full max-w-sm' onSubmit={handleSubmit}>
            <div className="space-y-1">
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Input
                  required
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-white dark:bg-secondary focus-visible:ring-primary-foreground"
                />
              </div>
            </div>
            <div className="flex justify-between">
              <Link to="/" className="pt-2 text-sm text-primary font-semibold mr-4 hidden lg:block">
                Sign in existing account
              </Link>
              <Link to="/" className="pt-2 text-sm text-primary font-semibold mr-4 block lg:hidden">
                Sign in
              </Link>
              <Button className="w-auto">Reset Password</Button>
            </div>
          </form>
        </div>

    </>
  );
}
